const LOAD_SELECTED_TIME = "LOAD_SELECTED_TIME"

export const selectTime = (selectedTime) => {
  return {
    type: LOAD_SELECTED_TIME,
    selectedTime
  }
}
